import { BaseService } from "./base.service";
import { ErrorWrapper, ResponseWrapper } from "./util";
import { GET_SYSTEM_CONFIG_URL } from "../.env";

import storeHelper from "@/store/helper";

export class CommonService extends BaseService {

  static async getConfigSystem() {
    try {
      const response = await this.request({ auth: true }).post(
        GET_SYSTEM_CONFIG_URL
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async getListPermission(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.agent-partner.get-group-permission"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async updateAccountPermissions(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.agent-partner.set-group-permission"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async getProvince(params = {}) {
    try {
      const response = await this.request().post(
        storeHelper.getUrl("cnps.agent.cfg.city-list"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      console.log(error);
      const message =
        error.response && error.response.data
          ? error.response.data.error
          : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getDistrict(params = {}) {
    try {
      const response = await this.request().post(
        storeHelper.getUrl("cnps.agent.cfg.district-list"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getWard(params = {}) {
    try {
      const response = await this.request().post(
        storeHelper.getUrl("cnps.agent.cfg.ward-list"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getBank(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper.getUrl("cnps.cstm.customer-list-bank"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  // agent bạnk

  static async getListPartnerCode(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.partner.search"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async getListInviteCode(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.report-agent-bank.list-invite-code"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async getListAgentPartner(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.partner.search"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getListAgentBank(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.agent-partner.list"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getListUserBank(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.agent-partner.list-manager"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async addUserBank(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.agent.agent-partner.create"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async lockUserBank(params = {}) {
    const newUrl = storeHelper.getUrl("cnps.agent.agent-partner.lock-unlock").replace("{id}", params.id);
    try {
      const response = await this.request({ auth: true }).post(
        newUrl,
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async updateUserBank(params = {}) {
    try {
      const response = await this.request({ auth: true }).put(
        storeHelper.getUrl("cnps.agent.agent-partner.update"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async detailteUserBank(id) {
    try {
      const response = await this.request({ auth: true }).get(
        storeHelper
          .getUrl("cnps.agent.agent-partner.detail")
          .replace("{id}", id)
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async ListranfersDevice(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.device.order-transfer-bank.get-list"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async getListSearchWarehouse(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.device.order-transfer-bank.get-list-inventory-bank"),
        params
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async superiors() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.staff.list-manager'),
        {}
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async cancelMovingTransferWarehouse(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-bank.reject-import'), params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvalReceivedDevice(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-bank.confirm-import'), params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


  static async detailTransferWarehouse(id) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.device.order-transfer-bank.detail'), { id })
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }



  // end agent bank

  static async uploadImage(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl("cnps.cfg.upload-image-s3"),
        params,
        {
          headers: { "Content-Type": "application/json/form-data" },
        }
      );
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async uploadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.upload-files-s3'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // end agent level

  static async getAgentLevel() {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.agent-partner.get-agent-level'))
      return new ResponseWrapper(response, response.data.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async maskReadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.summary.file.export.mark'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async receiveFile(params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.summary.file.export.receive'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


}

